// Import all required modules
import Accordion from '@bs/components/views/Accordion';
import Cards from '@bs/components/views/Cards';
import Carousel from '@bs/components/views/Carousel';
import Dropdown from '@bs/components/views/Dropdown';
import Header from '@bs/components/views/Header';
import InViewport from '@bs/components/views/InViewport';
import Search from '@bs/components/views/Search';
import SocialShare from '@bs/components/views/SocialShare';
import VideoYoutube from '@bs/components/views/VideoYoutube';

// Export reference to all modules in an object
export default {
  Accordion,
  Cards,
  Carousel,
  Dropdown,
  Header,
  InViewport,
  Search,
  SocialShare,
  VideoYoutube
};
